export const COMPANY_LINKEDIN_URL = process.env.REACT_APP_COMPANY_LINKEDIN_URL;

export const FULLPAGEJS_LICENSE_KEY = process.env.REACT_APP_FULLPAGE_KEY

export const CONTACT_FORM_URL = process.env.REACT_APP_CONTACT_FORM_URL